import type { PresetLabelTreeNode } from '@loc/server/interface/preset'


import { cls } from 'tagged-classnames-free';
interface CategoryTabsProps {
  categories: PresetLabelTreeNode[]
  activeKey: string
  onChange: (key: string) => void
}

function CategoryTabs(props: CategoryTabsProps) {
  const { categories, activeKey, onChange } = props

  return (
    <div className={cls`flex flex-col gap-3`}>
      {categories.map((category) => {
        const isActive = activeKey === category.code
        return (
          <button
            key={category.code}
            type='button'
            className={cls`
              cursor-pointer rounded-md p-1 pl-0 text-left text-sm font-semibold transition-colors
              ${isActive ? 'text-f-text' : 'text-f-text-tertiary hover:text-f-text-tertiary'}
            `}
            onClick={() => onChange(category.code)}
          >
            {category.displayName}
          </button>
        )
      })}
    </div>
  )
}

export default CategoryTabs
